import { create } from 'zustand';

const usePitchStatus = create((set) => ({
  pitchStatus: 'pending',
  setPitchStatus: (newPitchStatus) => set({ pitchStatus: newPitchStatus }),
}));

export default usePitchStatus;